module.exports = "<div class=\"booking-btn-container\">\n  <input type=\"button\" type=\"button\" value=\"BOOK NOW\" (click)=\"navigateToBooking()\">\n</div>"